import React from 'react';
import PropTypes from 'prop-types';
import Notification from 'erpcore/components/Notification';

/**
 * Notification Manager - Divisions Notifications
 * @return {Node} Returns Notification component
 */
// eslint-disable-next-line no-unused-vars
const ContactsNotification = ({ identifier, code, detail, notificationData }) => {
    switch (code) {
        case 'contact.itemSuccessfulyCreated':
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Contact successfully created!"
                    type="success"
                    expire="3500"
                />
            );
        case 'contact.itemSuccessfulyUpdated':
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Contact successfully updated!"
                    type="success"
                    expire="3500"
                />
            );
        case 'contact.itemSuccessfulyRemoved':
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Contact successfully deleted!"
                    type="success"
                    expire="3500"
                />
            );
        default:
            return null;
    }
};

ContactsNotification.defaultProps = {
    identifier: null,
    code: null,
    detail: null,
    notificationData: null
};

ContactsNotification.propTypes = {
    identifier: PropTypes.string,
    code: PropTypes.string,
    detail: PropTypes.string,
    notificationData: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array])
};

export default ContactsNotification;
